var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, ViewChild, CustomElement, Watch, Utils, PropertyConverters, Defaults } from '@pacem/pacem-core';
import { PacemBaseElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
let PacemRadioElement = class PacemRadioElement extends PacemBaseElement {
    convertValueAttributeToProperty(attr) {
        return attr;
    }
    constructor() {
        super();
        this._key = '_' + Utils.uniqueCode();
    }
    toggleReadonlyView(readonly) {
        this.span.hidden = !readonly;
        this._radio.hidden = /*this.label.hidden =*/ readonly;
    }
    get inputFields() {
        return [this._radio];
    }
    onChange(evt) {
        this.selected = this._radio.checked;
        const value = this.selected ? this._radio.value : undefined;
        return Utils.fromResult(value);
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._radio.id = this._label.htmlFor = this._key;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'name':
                this._radio.name = val;
                break;
            case 'selected':
                (this._radio.checked = val) ?
                    Utils.addClass(this, PCSS + '-selected')
                    :
                        Utils.removeClass(this, PCSS + '-selected');
                break;
        }
    }
    acceptValue(val) {
        this._radio.value = Utils.isNullOrEmpty(val) ? '' : val;
    }
    getViewValue(val) {
        if (!Utils.isNull(val))
            return this.caption;
        return '';
    }
};
__decorate([
    ViewChild("input[type=radio]")
], PacemRadioElement.prototype, "_radio", void 0);
__decorate([
    ViewChild("label")
], PacemRadioElement.prototype, "_label", void 0);
__decorate([
    ViewChild(`.${PCSS}-readonly`)
], PacemRadioElement.prototype, "span", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemRadioElement.prototype, "caption", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemRadioElement.prototype, "selected", void 0);
PacemRadioElement = __decorate([
    CustomElement({
        tagName: P + '-radio',
        template: `<${P}-span class="${PCSS}-readonly ${PCSS}-radio" text="{{ :host.caption }}"></${P}-span><input type="radio" class="${PCSS}-input" /><label class="${PCSS}-label ${PCSS}-radio ${PCSS}-viewfinder"><${P}-text text="{{ :host.caption }}"></${P}-text></label>`,
        shadow: Defaults.USE_SHADOW_ROOT
    })
], PacemRadioElement);
export { PacemRadioElement };
